/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `index` for the Caintra Connect frontend.
 * @module components/BusinessEventAttendancesCards/index
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import Switch from "@mui/material/Switch";
import styles from "./index.module.css";
import { useTranslation } from "react-i18next";

const BusinessEventAttendancesCards = ({ attendances, handleToggleActive }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.cardsContainer}>
      {attendances.map((attendance, index) => (
        <div
          key={index}
          className={`${styles.card} ${
            !attendance.asistio ? styles.inactiveCard : ""
          }`}
        >
          {/* Top row: Name and Switch */}
          <div className={styles.cardHeader}>
            <div className={styles.nameContainer}>
              <span className={styles.userName}>
                {attendance.nombreUsuario}
              </span>
            </div>
            <div className={styles.switchContainer}>
              <span
                className={`${styles.attendedLabel} ${styles.attendedTabletLabel}`}
              >
                {t("pages.attendance.attended")}
              </span>
              <Switch
                checked={attendance.asistio}
                onChange={() => handleToggleActive(index)}
                color="primary"
              />
              <span
                className={`${styles.attendedLabel} ${styles.attendedMobileLabel}`}
              >
                {t("pages.attendance.attended")}
              </span>
            </div>
          </div>

          {/* Company Name */}
          {/* <div className={styles.companyNameContainer}>
            <span className={styles.companyName}>{attendance.nombreEmpresa}</span>
          </div> */}

          {/* Phone */}
          {/* <div className={styles.infoRow}>
            <span className={styles.infoLabel}>
              {t("pages.attendance.phone")}
            </span>
            <span className={styles.infoValue}>
              {attendance.telefono ? attendance.telefono : "+52 811 0000 0000"}
            </span>
          </div> */}

          {/* Email */}
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>
              {t("pages.attendance.email")}
            </span>
            <span className={styles.infoValue}>
              {attendance.correoElectronicoUsuario
                ? attendance.correoElectronicoUsuario
                : "-"}
            </span>
          </div>

          {/* Commercial Name */}
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>
              {t("pages.attendance.commercialName")}
            </span>
            <span className={styles.infoValue}>{attendance.nombreEmpresa}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BusinessEventAttendancesCards;
